import React, { useState, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LOGOUT } from 'ConstComponents';
import { useHistory } from 'react-router';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import {
    MerchantOnboardingStatus as MERCHANT_ONBOARDING_STATUS,
    MerchantOnboardingGenerateOTP as GENERATE_OTP,
    MerchantOnboardingVerifyOTP as VERIFY_OTP
} from 'Components/Api/InstantPayAEPSAPI';

import { Container, Grid, Paper } from '@material-ui/core';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import Divider from '@material-ui/core/Divider';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { OTPModal } from 'Components/Modal/OTPModal';
import usePosition from 'Components/Posistion';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import { Select as BANK_SELECT } from 'Components/Api/DMTBankAPI';

const CustomContainer = HOCLoader(Container);

export const InstantPayMerchantOnboarding = () => {
    const classes = commonStyle();
    const history = useHistory();
    const [responseMessage, setResponseMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [eKYCMasterID, seteKYCMasterID] = useState(0);
    const [InWords, setInWords] = useState('');
    const [openOTP, setOpenOTP] = useState(false);
    const [isError, setIsError] = useState(false);
    const [Message, setMessage] = useState('');
    const [status, setStatus] = useState('PROCESS');
    const { latitude, longitude, error } = usePosition();
    const [bankList, setBankList] = useState([]);
    const [bankDefault, setBankDefault] = useState({
        Name: 'Select Bank',
        DefaultIFSC: ''
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        if (loading) {
            setLoading(false);
            return;
        }

        var request = {
            Pan: values.Pan,
            Aadhaar: values.Aadhaar,
            Mobile: values.Mobile,
            BankName: values.Bank.Name,
            IFSC: values.IFSC,
            AccountNumber: values.AccountNumber,
            Email: values.Email,
            Latitude: latitude,
            Longitude: longitude
        };

        var requestObj = JSON.stringify(request);

        setIsError(false);
        setLoading(true);
        const response = await GENERATE_OTP(requestObj);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        let data = JSON.parse(response.data);

        setSeverity('success');
        setResponseMessage(data.Message);
        seteKYCMasterID(data.eKYCMasterID);

        setIsError(true);
        setOpenOTP(true);
        return;
    };

    const [FormObj, setFormObj] = useState({
        Mobile: '',
        Pan: '',
        AccountNumber: '',
        Email: '',
        Aadhaar: '',
        DefaultIFSC: '',
        IFSC: '',
        Bank: bankDefault,
        Latitude: latitude,
        Longitude: longitude
    });

    const reset = () => {
        setInWords('');
        setFormObj({
            Mobile: '',
            Pan: '',
            AccountNumber: '',
            Email: '',
            Aadhaar: '',
            IFSC: '',
            Bank: bankDefault,
            Latitude: latitude,
            Longitude: longitude
        });
    };

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'number'),
        Pan: Yup.string()
            .length(10, 'Must be 10 alpha numberic')
            .required(PLEASE_PROVIDE_VALID + ' pan'),
        Email: Yup.string().required(PLEASE_PROVIDE_VALID + 'email'),
        AccountNumber: Yup.string().required(
            PLEASE_PROVIDE_VALID + 'AccountNumber'
        ),
        Aadhaar: Yup.string()
            .length(12, 'Must be 12 digit')
            .required(PLEASE_PROVIDE_VALID + ' aadhaar')
    });

    const CustomOtpModal = openOTP ? (
        <OTPModal
            isOpen={openOTP}
            title="OTP"
            error={responseMessage}
            submitCallback={(value) => {
                VerifyOTP(value);
            }}
            resendCallback={(value) => {}}
            onDismissCallback={(value) => {}}
        />
    ) : null;

    const VerifyOTP = async (otpObj) => {
        setLoading(true);
        setOpenOTP(false);

        const { OTP } = otpObj;
        let RequestObj = {
            OTP: OTP,
            eKYCMasterID: eKYCMasterID
        };

        var response = await VERIFY_OTP(JSON.stringify(RequestObj));
        setLoading(false);

        setResponseMessage(response.data);
        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            setOpenOTP(true);
            return;
        }

        if (response.status) {
            setIsError(true);
            setOpenOTP(false);
            setSeverity('success');
            setResponseMessage(response.data);
            history.push('/IPAEPS');
            return;
        }
    };

    useEffect(() => {
        MerchantStatus();
        selectBank();
    }, []);

    const MerchantStatus = async () => {
        setLoading(true);
        const response = await MERCHANT_ONBOARDING_STATUS();
        setLoading(false);
        if (!response.isAuthorized) {
            LOGOUT();
        }
        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
            setStatus('FAILURE');
            setMessage(response.data);
        }
        var data = JSON.parse(response.data);

        if (data.Message === 'User already Onboarded') history.push('/IPAEPS');

        setResponseMessage(data.Message);
        setIsError(true);
    };

    const selectBank = async () => {
        const response = await BANK_SELECT();

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setResponseMessage(response.data);
            setIsError(true);
        }

        var data = JSON.parse(response.data);
        let objWithSelectAll = [bankDefault, ...data];

        setBankList(objWithSelectAll);
    };

    const TransferForm = ({ setFieldValue }) => {
        return (
            <Grid
                item
                container
                margin="normal"
                xs={12}
                md={12}
                sm={12}
                lg={12}
                spacing={2}
            >
                <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Form>
                        <h2 className={classes.PaperHead_h2}>
                            MerchantOnboarding
                        </h2>
                        <Grid item xs={12}>
                            <Paper className={classes.PaperStyle}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <MaterialNumberField
                                            label="Mobile Number"
                                            name="Mobile"
                                            length="10"
                                            placeholder="Mobile Number"
                                            title="Mobile Number"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <MaterialNumberField
                                            label="Aadhaar"
                                            name="Aadhaar"
                                            length="12"
                                            placeholder="Email"
                                            title="Aadhaar"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <MaterialTextField
                                            label="Pan Number"
                                            name="Pan"
                                            length="10"
                                            placeholder="Pan Number"
                                            title="Pan Number"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <MaterialTextField
                                            label="Email"
                                            name="Email"
                                            length="35"
                                            placeholder="Email"
                                            title="Email"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <MaterialNumberField
                                            label="Account Number"
                                            name="AccountNumber"
                                            length="21"
                                            placeholder="AccountNumber"
                                            title="Account Number"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Field
                                            component={AutoCompleteTextView}
                                            defaultValue={bankDefault}
                                            FieldName="Bank"
                                            name="Bank"
                                            onCustomCallback={(name, value) => {
                                                setFieldValue(
                                                    'IFSC',
                                                    value.DefaultIFSC
                                                );
                                                setBankDefault({
                                                    Name: value.Name,
                                                    DefaultIFSC:
                                                        value.DefaultIFSC
                                                });
                                            }}
                                            options={bankList}
                                            getOptionLabel={(option) =>
                                                option.Name
                                            }
                                            getOptionSelected={(
                                                option,
                                                value
                                            ) => option.Name === value.Name}
                                            textFieldProps={{
                                                label: 'Bank'
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Divider
                                    variant="middle"
                                    className="rechdevider"
                                />

                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    spacing={2}
                                    container
                                    className={classes.footerGrid}
                                >
                                    <Grid item xs={12} sm={12} md={6} lg={6}>
                                        <SecondaryButton
                                            variant="contained"
                                            color="secondary"
                                            type="reset"
                                            title="Reset"
                                            onClick={() => {
                                                reset();
                                            }}
                                            className={
                                                classes.CustomDangerButtonStyle
                                            }
                                        >
                                            Reset
                                        </SecondaryButton>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={6} lg={6}>
                                        <PrimaryButton
                                            type="submit"
                                            title="Generate OTP"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loading}
                                        >
                                            Generate OTP
                                        </PrimaryButton>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Form>
                </Grid>
            </Grid>
        );
    };
    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={handleSubmit}
                resetForm={FormObj}
            >
                {TransferForm}
            </Formik>
            {CustomOtpModal}

            {/* {isAlertErrorOpen && (
                <FailTransactionResponse
                    isOpen={isAlertErrorOpen}
                    title={status}
                    Message={Message}
                    OkButtonClick={(request) => {
                        setIsAlertErrorOpen(false);
                    }}
                />
            )}

            {isAlertOpen && (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="AEPS"
                    message="Are you sure to do onboarding?"
                    request={confirmAlertRequest}
                    positiveButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            )} */}
        </CustomContainer>
    );
};
